import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'お知らせ',

  // model
  noticeModel: [],
  serviceModel: [],

  // サービス運用者用
  serviceDetailModel: {},

  // 検索
  filters: {
    searchService: '',
    searchDate: '',
    searchListType: '',
  }
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceParams, serviceDetailParams}) {
    return new Promise((resolve, reject) => {
      const isAdmin = this.getters['auth/isAdmin']

      const types = []
      const methods = []
      const parameters = []

      // システム管理者の場合
      if (isAdmin) {
        types.push('service')
        methods.push('v1ServiceListGet')
        parameters.push(serviceParams)

      // サービス運用者の場合
      } else {
        types.push('service')
        methods.push('v1ServiceDetailGet')
        parameters.push(serviceDetailParams)
      }

      ApiManager.request(types, methods, parameters)
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            if (isAdmin) {
              commit('setServiceModel', res[0].data.serviceInfo)
              console.log('serviceModel', state.serviceModel)
            } else {
              commit('setServiceDetailModel', res[0].data.serviceBasicInfo)
              console.log('serviceDetailModel', state.serviceDetailModel)
            }
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * お知らせ一覧を読出し
   */
  loadNoticeList ({commit}, {noticeParams}) {
    return new Promise((resolve, reject) => {
      const isBot = this.state.noticeList.isBot
      const type = isBot ? 'noticeBot' : 'notice'

      ApiManager.request(
        [type],
        ['v1NoticeListGet'],
        [noticeParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            switch (noticeParams.filters.listType) {
              case 1:
                commit('setNoticeModel', res[0].data.deliveriedNotices)
                break
              case 2:
                commit('setNoticeModel', res[0].data.reservedNotices)
                break
              case 3:
                commit('setNoticeModel', res[0].data.repeatedNotices)
                break
            }
            console.log('noticeModel', state.noticeModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  deleteNotice ({commit}, {noticeParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
          ['notice'],
          ['v1NoticeDeliveryDelete'],
          [noticeParams])
          .then(res => {
            let status = Utility.parseResponse(res)
            if (status.result) {
              resolve()
            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })
    })
  },
  deleteNoticeDetail ({commit}, {noticeParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
          ['notice'],
          ['v1NoticeDeliveryDetailDelete'],
          [noticeParams])
          .then(res => {
            let status = Utility.parseResponse(res)
            if (status.result) {
              console.log('noticeModel', state.noticeModel)
              resolve()
            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })
    })
  },
  reset({commit}) {
    commit('resetState')
  }
}

const mutations = {
  // model
  setNoticeModel (state, data) {
    Vue.set(state, 'noticeModel', data)
  },
  setServiceModel (state, data) {
    Vue.set(state, 'serviceModel', data)
  },
  setServiceDetailModel (state, data) {
    Vue.set(state, 'serviceDetailModel', data)
  },

  setInputFilter (state, {key, value}) {
    Vue.set(state.filters, key, value)
  },

  resetState (state) {
    Vue.set(state, 'noticeModel', [])
    Vue.set(state, 'serviceModel', [])
    Vue.set(state, 'serviceDetailModel', {})

    state.filters.searchService = ''
    state.filters.searchDate = ''
    state.filters.searchListType = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}